import { axios } from "@/plugins/axios";
import { merge } from "lodash";
import { KeyValuePair } from '@/helpers/Interfaces';

export default class DynamicModalService
{
    public static async GetDictionary(endpoint: string, dynamicParams: Record<string, any>): Promise<KeyValuePair[]>
    {
        return (
            await axios.get(`admin/forms/dynamic-modal/${endpoint}`, {
                params: merge({}, dynamicParams),
            })
        ).data;
    }

    public static async ExecuteScript(licence: string, id: string, scriptId: string, scriptConfigId: string, formId: string, tableRowIndex: number | null, withValidation: boolean, model: Record<string, unknown>, baseData: Record<string, unknown>): Promise<any>
    {
        const action = id.split('/').length > 1 ? 'bpmn-execute' : 'bpmn-start';

        return (await axios.post(`dynamic-modal/${licence}/${id}/${action}/script/${scriptId}`, {
            formData: model,
            baseFormData: baseData
        }, {
            params: merge({
                formId: formId,
                scriptConfigId: scriptConfigId,
                tableRowIndex,
                withValidation: withValidation
            })
        })).data;
    }

    public static async ValidateForm(licence: string, id: string, model: Record<string, unknown>): Promise<any>
    {
        const action = id.split('/').length > 1 ? 'bpmn-execute' : 'bpmn-start';

        return (await axios.post(`dynamic-modal/${licence}/${id}/${action}/validate`, {
            formData: model
        })).data;
    }
}
